export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  children?: INavigationRoute[]
}

export default {
  root: {
    name: 'admin',
    displayName: 'menu.home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'menu.dashboard',
      meta: {
        icon: 'dashboard',
      },
    },
    {
      name: 'users',
      displayName: 'menu.users',
      meta: {
        icon: 'group',
      },
      children: [
        {
          name: 'users',
          displayName: 'menu.users',
        },
        {
          name: 'faq',
          displayName: 'menu.faq',
        },
        {
          name: 'notice',
          displayName: 'menu.notice',
        },
      ],
    },
    {
      name: 'stores',
      displayName: 'menu.stores',
      meta: {
        icon: 'storefront',
      },
    },
    {
      name: 'jrs-admin',
      displayName: 'menu.jrs',
      meta: {
        icon: 'vuestic-iconset-files',
      },
      children: [
        {
          name: 'jrs-list',
          displayName: 'menu.jrs-list',
        },
        {
          name: 'jrs-assessment',
          displayName: 'menu.jrs-assessment',
        },
        {
          name: 'jrs-verification',
          displayName: 'menu.jrs-verification',
        },
        {
          name: 'scraping',
          displayName: 'menu.scraping',
        },
      ],
    },
    {
      name: 'promotions',
      displayName: 'menu.promotions',
      meta: {
        icon: 'campaign',
      },
    },
    {
      name: 'ads',
      displayName: 'menu.ads',
      meta: {
        icon: 'ads_click',
      },
      children: [
        {
          name: 'jrs-ads',
          displayName: 'menu.jrs-ads',
        },
        {
          name: 'alarm-ads',
          displayName: 'menu.alarm-ads',
        },
        {
          name: 'search-suggestion-ads',
          displayName: 'menu.search-suggestion-ads',
        },
        {
          name: 'search-sns-ads',
          displayName: 'menu.search-sns-ads',
        },
      ],
    },
    {
      name: 'orders',
      displayName: 'menu.orders',
      meta: {
        icon: 'credit_card',
      },
    },
    {
      name: 'settings',
      displayName: 'menu.settings',
      meta: {
        icon: 'settings',
      },
    },
  ] as INavigationRoute[],
}
